// Personalizador Zepto: evita que o canvas fique preso dentro do selo (vira 64px)
(() => {
  const WRAP_SELECTORS = ['.product__media-image-wrapper', '.pdp-slide'];

  const findWrapper = (node) => node.closest?.(WRAP_SELECTORS.join(','));

  function normalize(el) {
    const wrapper = findWrapper(el);
    if (!wrapper) return;
    const style = getComputedStyle(wrapper);
    if (style.position === 'static') wrapper.style.position = 'relative';
    if (el.parentElement !== wrapper) wrapper.appendChild(el);
    Object.assign(el.style, {
      position: 'absolute',
      inset: '0',
      width: '100%',
      height: '100%',
      margin: '0',
      pointerEvents: 'none'
    });
    const canvas = el.querySelector('canvas');
    if (canvas) {
      Object.assign(canvas.style, {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center'
      });
    }
  }

  const rescan = (root = document) => {
    root.querySelectorAll('.pplr_preview_wrapper').forEach(normalize);
  };

  const boot = () => {
    rescan();
    const mo = new MutationObserver(muts => {
      muts.forEach(mut => {
        mut.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches?.('.pplr_preview_wrapper')) {
            normalize(node);
            return;
          }
          if (node.querySelector?.('.pplr_preview_wrapper')) rescan(node);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

/* PERF:BEGIN — THEME SPLIT */
(function() {
  function loadScript(src, marker) {
    if (!src) return;
    if (marker && document.querySelector('script[data-perf-load="' + marker + '"]')) return;
    var script = document.createElement('script');
    script.defer = true;
    script.src = src;
    if (marker) {
      script.dataset.perfLoad = marker;
    }
    document.body.appendChild(script);
  }

  var coreSrc = window.__themeCoreSrc;
  if (!coreSrc && window.Shopify && typeof Shopify.assetUrl === 'function') {
    try {
      coreSrc = Shopify.assetUrl('theme-core.js');
    } catch (error) {
      coreSrc = null;
    }
  }
  loadScript(coreSrc, 'theme-core');

  var cartSrc = window.__themeCartSrc;
  loadScript(cartSrc, 'cart-core');
})();
/* PERF:END — THEME SPLIT */
